import { TTextIconProps } from './TextIcon.types';
import { STextIcon } from './TextIcons.styles';

const TextIcon = ({ revert = false, ...props }: TTextIconProps) => {
  return <STextIcon revert={revert} {...props} />;
};

export default TextIcon;
